import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronDown, ListFilter } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { viewsForPath } from '@/lib/navigation';

/**
 * "Views ▾" — the pre-filtered views of the current page (links in lib/navigation.ts whose `to`
 * is this path plus a query string). Rendered automatically by `PageHeader`, left of the page's
 * own actions/search, so a page gets it just by having views defined. Picking one navigates to the
 * same path with the view's params; the page applies them and strips them (filtersFromSearch).
 * Renders nothing when the page has no views.
 */
export function ViewsMenu() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const views = viewsForPath(pathname);
  if (!views.length) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="h-9 gap-1.5 px-3 text-sm font-normal">
          <ListFilter className="h-3.5 w-3.5 text-muted-foreground" />Views<ChevronDown className="h-3 w-3 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[220px]">
        <DropdownMenuLabel className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">Quick views</DropdownMenuLabel>
        {views.map((v) => (
          <DropdownMenuItem key={v.to} onSelect={() => navigate(v.to)} className="cursor-pointer text-sm">{v.label}</DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
